import { startOfDay, subDays } from 'date-fns';

export const CALL_ACTIVITY_PERIODS = {
  TODAY: 'today',
  LAST_3_DAYS: 'last-3-days',
  LAST_7_DAYS: 'last-7-days',
  LAST_30_DAYS: 'last-30-days',
};

export const CALL_ACTIVITY_PERIOD_OPTIONS = [
  { value: CALL_ACTIVITY_PERIODS.TODAY, label: 'Today' },
  { value: CALL_ACTIVITY_PERIODS.LAST_3_DAYS, label: 'Last 3 days' },
  { value: CALL_ACTIVITY_PERIODS.LAST_7_DAYS, label: 'Last 7 days' },
  { value: CALL_ACTIVITY_PERIODS.LAST_30_DAYS, label: 'Last 30 days' },
];

export const getCallActivitySince = (period) => {
  const now = new Date();

  switch (period) {
    case CALL_ACTIVITY_PERIODS.LAST_3_DAYS:
      return startOfDay(subDays(now, 2));
    case CALL_ACTIVITY_PERIODS.LAST_7_DAYS:
      return startOfDay(subDays(now, 6));
    case CALL_ACTIVITY_PERIODS.LAST_30_DAYS:
      return startOfDay(subDays(now, 29));
    case CALL_ACTIVITY_PERIODS.TODAY:
    default:
      return startOfDay(now);
  }
};
